<template>
  <div class="helpCenterBox">
    <div class="helpCenterBanner">
      <span>帮助中心</span>
    </div>
    <div class="helpCenterCon">
      <div class="helpCenterMain">
        <div class="helpTitle">
          <span>帮助中心</span>
          <ul>
            <li v-for="(item,index) in titlelist" :key="index" @click="tabFn(index)">{{item}}</li>
          </ul>
        </div>
        <div class="helpConter">
          <help-login v-if="num==0"></help-login>
          <help-real v-if="num==1"></help-real>
          <help-sign v-if="num==2"></help-sign>
          <help-performance v-if="num==3"></help-performance>
          <help-warning v-if="num==4"></help-warning>
          <help-service v-if="num==5"></help-service>
          <help-user v-if="num==6"></help-user>
          <open-plugin v-if="num==7"></open-plugin>
          <knowledge v-if="num==8"></knowledge>
          <familiar-problem v-if="num==9"></familiar-problem>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import helpLogin from "./helpCenter/helpLogin.vue";
import helpReal from "./helpCenter/helpReal.vue";
import helpSign from "./helpCenter/helpSign.vue";
import helpPerformance from "./helpCenter/helpPerformance.vue";
import helpWarning from "./helpCenter/helpWarning.vue";
import helpService from "./helpCenter/helpService.vue";

import helpUser from "./helpCenter/helpUser.vue";
import familiarProblem from "./helpCenter/familiarProblem.vue";
import knowledge from "./helpCenter/knowledge.vue";
import openPlugin from "./helpCenter/openPlugin.vue";

export default {
  data() {
    return {
      num: 0,
      titlelist: [
        "注册登录",
        "实名认证",
        "签约管理",
        "履约管理",
        "预警提醒",
        "司法服务",
        "用户中心",
        "开放平台",
        "电子合同相关知识",
        "常见问题"
      ]
    };
  },
  methods: {
    tabFn(num) {
      this.num = num;
      $(".helpTitle li").css("color", "#646464");
      $(".helpTitle li")
        .eq(num)
        .css("color", "#EC3838");
    }
  },
  components: {
    helpLogin,
    helpReal,
    helpSign,
    helpPerformance,
    helpWarning,
    helpService,
    helpUser,
    familiarProblem,
    knowledge,
    openPlugin
  }
};
</script>
<style lang="scss">
.helpCenterBox {
  width: 100%;
  .helpCenterBanner {
    width: 100%;
    height: 280px;
    background: url("../../assets/images/helpCenter/helpcentre_banner_img.png")
      no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 44px;
      color: #ffffff;
    }
  }
  .helpCenterCon {
    width: 100%;
    background: #f7f8f9;
    padding-top: 20px;
    padding-bottom: 20px;
    .helpCenterMain {
      width: 1180px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .helpTitle {
        width: 180px;
        span {
          display: block;
          width: 100%;
          height: 48px;
          display: flex;
          align-items: center;
          background: #2d313a;
          font-size: 16px;
          color: #ffefee;
          text-indent: 40px;
        }
        ul {
          display: block;
          width: 100%;
          padding: 0 20px;
          box-sizing: border-box;
          background-color: #fff;
          li {
            width: 100%;
            height: 48px;
            display: flex;
            align-items: center;
            text-indent: 20px;
            font-size: 14px;
            color: #646464;
            border-bottom: 1px solid #dcdcdc;
            cursor: pointer;
          }
          li:last-child {
            border: 0;
          }
          li:first-child {
            color: #ec3838;
          }
          li:hover {
            color: #ec3838;
          }
          .active {
            color: #ec3838;
          }
        }
      }
      .helpConter {
        width: 980px;
        padding: 20px;
        background: #ffffff;
        border: 1px solid #e4e8eb;
        border-radius: 0 3px 3px 3px;
        box-sizing: border-box;
        .bigTitle {
          width: 100%;
          height: 40px;
          line-height: 40px;
          background: #f8f8f8;
          font-size: 16px;
          color: #505050;
          margin-bottom: 20px;
          padding-left: 10px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          margin-top: 20px;
          span {
            display: inline-block;
            width: 20px;
            height: 20px;
            position: relative;
            background: url("../../assets/images/helpCenter/add.png");
            background-size: 15px 15px;
            background-repeat: no-repeat;
            background-position: center center;
            margin-right: 4px;
          }
        }
        .bigTitle:nth-child(1) {
          margin-top: 0;
        }
        .smallTile {
          overflow: hidden;
          p {
            margin: 5px 0;
            font-size: 14px;
            color: #828282;
            text-indent: 10px;
          }
          img {
            margin-left: 10px;
          }
        }
      }
      .helpItem {
        p {
          font-size: 14px;
          color: #828282;
          line-height: 30px;
          text-indent: 10px;
          span {
            display: inline-block;
            width: 17px;
            height: 13px;
            vertical-align: middle;
            margin-right: 5px;
          }
        }
        p:first-child {
          color: #2899ef;
          span {
            background: url("../../assets/images/helpCenter/Group6Copy10.png");
          }
        }
        p {
          span {
            background: url("../../assets/images/helpCenter/Group7Copy6.png");
          }
        }
        div {
          p:last-child {
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>
